/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class AzureConnectAccountTerraformRequest {
  /**
  * The account type - restore or source
  */
  'accountType': AzureConnectAccountTerraformRequestAccountTypeEnum;
  /**
  * The tenant ID
  */
  'tenantId': string;
  /**
  * The subscription ID. This field is required if managementGroupId is not provided. (Cannot be provided together with managementGroupId.) 
  */
  'subscriptionId'?: string;
  /**
  * The management group ID. This field is required if subscriptionId is not provided. (Cannot be provided together with subscriptionId.) 
  */
  'managementGroupId'?: string;
  /**
  * The application ID for the restore app. This field is required if accountType is Restore. 
  */
  'restoreAppId'?: string;
  /**
  * The location of the restore identity. This field is required if accountType is Restore. 
  */
  'restoreIdentityLocation'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "accountType",
      "baseName": "accountType",
      "type": "AzureConnectAccountTerraformRequestAccountTypeEnum",
      "format": ""
    },
    {
      "name": "tenantId",
      "baseName": "tenantId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "subscriptionId",
      "baseName": "subscriptionId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "managementGroupId",
      "baseName": "managementGroupId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "restoreAppId",
      "baseName": "restoreAppId",
      "type": "string",
      "format": ""
    },
    {
      "name": "restoreIdentityLocation",
      "baseName": "restoreIdentityLocation",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureConnectAccountTerraformRequest.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum AzureConnectAccountTerraformRequestAccountTypeEnum {
  Restore = 'restore',
  Source = 'source'
}

